<div id="app-header">
    <div class="left-header">
        <div id="app-logo" class="left-1">
            <div class="logo" title="Arizona GeoSpatial Intake & Validation"></div>  
        </div>
        <div class="left-2">
            <div class="pane-menu">
                <mat-button-toggle-group #group="matButtonToggleGroup" [value]="selectedContentMenu" (change)="selectContentMenu($event.value, null, true)">
                    <mat-button-toggle *ngFor="let contentMenu of contentMenus" [value]="contentMenu" (click)="clickContentMenu(contentMenu)">
                        <div>{{contentMenu.label}}</div>
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>
            <div class="lower-menu" *ngIf="selectedContentMenu">
                <div class="schema-menu" *ngIf="selectedContentMenu.hasSchemaMenu">
                    <label>Schema:</label>
                    <select name="schema" [(ngModel)]="selectedSchema"  (ngModelChange)="selectSchema($event)">
                        <option *ngFor="let schema of schemaDefinedByList" [ngValue]="schema">{{schema.name}}</option>
                    </select>
                    <!-- <mat-button-toggle-group [value]="selectedSchema" (change)="selectSchema($event.value)">
                        <mat-button-toggle *ngFor="let schema of schemaDefinedByList" [value]="schema">
                            <div>{{schema.name}}</div>
                        </mat-button-toggle>
                    </mat-button-toggle-group> -->
                </div>
                <div class="model-menu" *ngIf="hasModelMenu">
                    <label>Fields:</label>
                    <select name="model" [(ngModel)]="selectedModel"  (ngModelChange)="selectModel($event)">
                        <ng-container *ngFor="let model of modelList">
                            <option *ngIf="showAllField||model.value!==''" [ngValue]="model">{{model.label}}</option>
                        </ng-container>
                    </select>
                </div>
                <div class="map-filter" *ngIf="selectedContentMenu.hasMapFilter">
                    <app-feat-map-filter></app-feat-map-filter>
                </div>
            </div>
        </div>  
    </div>

    <div class="middle-header">
        <div class="address-search" *ngIf="selectedContentMenu?.hasMapFilter">
            <app-feat-address-search #mapSearch (selectAddress)="onSelectAddress($event)"></app-feat-address-search>
        </div>
    </div>
    <div class="right-header">
        <div *ngIf="isAdminUser||customerType==='integrator'" class="agency-list-container" >
            <div class="agency-info">
                <ng-container *ngIf="customerType === 'integrator'"></ng-container>
                <ng-container *ngIf="customerType !== 'integrator'">
                    <!-- <div *ngIf="agencyParentName">{{agencyParentName}} &gt; </div> -->
                    <div> {{agencyName}} </div>
                    <!-- <div *ngIf="selectedCustomerId !== selfCustomerId && selectedCustomerId">
                        : {{selectedCustomer.nameShort}}
                    </div> -->
                </ng-container>
            </div>
            <app-feature-available-agencies [agencyType]="customerType" [selectedAgencyId]="selectedCustomerId" selectWidth="unset" (changeAgency)="onChangeCustomer($event)"></app-feature-available-agencies>
        </div>
        <div class="info-wrap">
            <div class="user-info">
                <div class="long-transaction-icon" (click)="clickTransactionLog()">
                    <div style="margin-right:4px;">Logger</div>
                    <div [class]="longTransactionClass"></div>
                </div>
                <i class="glyphicons glyphicons-question-sign" (click)="clickTooltipHelp()"></i>
                <i class="glyphicons glyphicons-cogwheel" (click)="positionSettingMenu.click()">
                    <i #positionSettingMenu class="position-icon" [matMenuTriggerFor]="matSettingsMenu"></i>
                </i>
                
                <i class="glyphicons glyphicons-user" (click)="positionUserMenu.click()">
                    <i #positionUserMenu class="position-icon" [matMenuTriggerFor]="matUserMenu"></i>
                </i>
            </div>
        </div>
    </div>
</div>
<mat-menu #matSettingsMenu="matMenu" classList="popup-menu setting-menu">
    <ng-container *ngFor="let item of settingsMenu">
        <button *ngIf="!item.hidden" mat-menu-item title="{{item.tooltip ? item.tooltip : ''}}" (click)="onClickSettingMenu(item)">{{item.label}}</button>
    </ng-container>
</mat-menu>
<mat-menu #matUserMenu="matMenu" classList="popup-menu">
    <button mat-menu-item *ngFor="let item of userMenu" title="{{item.tooltip ? item.tooltip : ''}}" (click)="clickUserMenuItem(item)">
        <i *ngIf="item.className" [className]="item.className" style="vertical-align:middle;"></i>
        {{item.label}}
    </button>
</mat-menu>